import React from "react";
import Drawer from "@material-ui/core/Drawer";
import ReactECharts from "echarts-for-react";
import { makeStyles } from "@material-ui/core/styles";
import * as V from 'styles/variables';

const useStyles = makeStyles({
  drawerPaper: {
    width: 500,
    padding: 8,
  },
});

const PictreeReportPieDrawer = ({ open, onClose, data }) => {
  const classes = useStyles();

  const pieData = data.map(item => ({
    name: item.tag_label,
    value: item.total_count,
  }));

  const option = {
    title: { text: "タグ別割合", left: "center" },
    tooltip: { trigger: "item" },
    color: V.genericColorPallette,
    series: [
      {
        type: "pie",
        radius: "60%",
        data: pieData,
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      },
    ],
  };

  return (
    <Drawer
      anchor="right"
      variant="persistent"
      open={open}
      onClose={onClose}
      classes={{ paper: classes.drawerPaper }}
    >
      <ReactECharts option={option} style={{ height: 500 }} />
    </Drawer>
  );
};

export default PictreeReportPieDrawer;
